/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import React, { useEffect } from 'react';
import { Box } from '@mui/material';

import MonthDaySelector from './MonthDaySelector';
import { IAnnualScheduleProps } from './CreateSchedule.Model';

const AnnualSchedule: React.FC<IAnnualScheduleProps> = ({
  t,
  control,
  label,
  showLabel,
  selectAnnualMonth,
  setSelectAnnualMonth,
  selectAnnualDay,
  setSelectAnnualDay,
  isMonthOpen,
  setIsMonthOpen,
  setAnnualPayload,
}) => {
  useEffect(() => {
    if (selectAnnualMonth && selectAnnualDay) {
      const annualPayload = `M${selectAnnualMonth}-${selectAnnualDay}`;
      setAnnualPayload?.(annualPayload);
    }
  }, [selectAnnualMonth, selectAnnualDay]);

  return (
    <>
      {showLabel && label}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          padding: showLabel ? '0.75rem 0' : '0',
        }}>
        <MonthDaySelector
          t={t}
          control={control}
          monthValue={selectAnnualMonth}
          setMonthValue={setSelectAnnualMonth}
          dayName="AnnualDay"
          setDayValue={setSelectAnnualDay}
          isMonthOpen={isMonthOpen}
          setIsMonthOpen={setIsMonthOpen}
          showLabel={showLabel}
        />
      </Box>
    </>
  );
};

export default AnnualSchedule;
